export default {
  brand: 'devdeck',
  domain: 'devdeck.ru',
  title: 'devdeck.ru — бесплатные инструменты разработчика',
  description:
    'Быстрые локальные инструменты разработчика: JSON formatter, YAML formatter, Base64, UUID generator и regex tester.',
  metrikaId: '110292698',
  ogImage: 'https://devdeck.ru/og-image.png',
}
